import { combineReducers } from '@reduxjs/toolkit'

import BoardModule, { BoardState } from './board'
import NotifyModule, { NotifyState } from './notify'
import StickyModule, { StickyState } from './sticky'
import ReportModule, { ReportState } from './report'

export interface RootState {
	board: BoardState,
	notify: NotifyState,
	sticky: StickyState,
	report: ReportState,
}

export const RootReducer = combineReducers({
	board: BoardModule.reducer,
	notify: NotifyModule.reducer,
	sticky: StickyModule.reducer,
	report: ReportModule.reducer,
})